import TextField, { TextFieldProps } from "@powerdiary/components-library/lib/components/Controls/TextField";
import { StripeError, StripeCardNumberElementChangeEvent } from "@stripe/stripe-js";
import { CardNumberElement, CardNumberElementProps } from "@stripe/react-stripe-js";
import StripeInput from "../StripeInput";

export type StripeCardNumberTextFieldProps = { onChange?: (e: StripeCardNumberElementChangeEvent) => void } & Omit<
    TextFieldProps,
    "onChange"
> &
    CardNumberElementProps;

export default function StripeCardNumberTextField({
    children,
    InputProps,
    InputLabelProps,
    size = "medium",
    onChange,
    options,
    onReady,
    ...restProps
}: StripeCardNumberTextFieldProps) {
    return (
        <TextField
            {...restProps}
            size={size}
            variant="outlined"
            slotProps={{
                input: {
                    ...InputProps,
                    inputComponent: StripeInput,
                    inputProps: {
                        component: CardNumberElement,
                        options: options,
                        onReady: onReady,
                        onChange: onChange as unknown as TextFieldProps["onChange"],
                        onLoadError: (error: StripeError) => {
                            console.error("Stripe Element failed to load", error);
                        },
                    },
                },
                inputLabel: {
                    ...InputLabelProps,
                    shrink: true,
                },
            }}
        >
            {children}
        </TextField>
    );
}
